<template>
    <div>
        <portal v-if="isMounted" to="load_prev">
            <div class="mt-4 mb-4 text-center" v-if="firstPage > 1">
                <button class="btn btn-primary trigger-load-prev ml-auto mr-auto" v-if="!prevLoading" :disabled="loading || prevLoading"
                        @click="loadItems(firstPage-1)">
                    <template>
                        {{ $translate('Weberbuero::Template.loadPrevItems') }}
                    </template>
                </button>
                <loading-animation v-if="prevLoading" class="ml-auto mr-auto"></loading-animation>
            </div>
            <div class="product-list row mt-0" v-if="prevItems">
                <div class="category-item__col col-6 col-sm-6 col-md-4 col-xxl-3" :class="{'col-lg-4' : cols === 3, 'col-lg-3' : cols === 4}" v-for="item in prevItems">
                    <category-item :item-data="item.data" :key="item.id"/>
                </div>
            </div>
        </portal>
        <div class="product-list row mt-0">
             <div class="category-item__col col-6 col-sm-6 col-md-4 col-xxl-3" :class="{'col-lg-4' : cols === 3, 'col-lg-3' : cols === 4}" v-for="item in items">
                <category-item :item-data="item.data" :key="item.id"/>
            </div>
        </div>
        <div class="mt-4 mb-4 text-center" v-if="lastPage < pageMax">
            <loading-animation class="trigger-load-more mb-5"></loading-animation>
        </div>
    </div>
</template>

<script>
import ApiService from 'ceres/app/services/ApiService';
import {mapState} from 'vuex';

export default {
    props: {
        currentCategoryPage: {},
        itemsPerPage: {},
        pageMax: {},
        sorting: {},
        facetData: {},
        cols:{
            Number: String,
            default: 3
        }
    },
    data() {
        return {
            prevItems: [],
            items: [],
            loading: false,
            prevLoading: false,
            currentPage: 1,
            firstPage: 1,
            lastPage: 1,
            isMounted: false
        };
    },

    mounted()
    {
        this.currentPage = this.currentCategoryPage;
        this.firstPage = this.currentCategoryPage;
        this.lastPage = this.currentCategoryPage;
        this.isMounted = true;

        this.$nextTick(() =>
        {
            let that = this;
            $(window).scroll(function(){
                that.triggerLoadMoreCheck();
            });
        });
    },

    computed: {
        ...mapState({
            currentCategory: state => state.navigation.currentCategory,
        }),
    },
    methods: {
        triggerLoadMoreCheck(){
            let el = document.querySelector(".trigger-load-more");
            if(el !== null){
                var top = el.offsetTop;
                var left = el.offsetLeft;
                var width = el.offsetWidth;
                var height = el.offsetHeight;

                while(el.offsetParent) {
                    el = el.offsetParent;
                    top += el.offsetTop;
                    left += el.offsetLeft;
                }

                let loadMore =
                    top < (window.pageYOffset + window.innerHeight) &&
                    left < (window.pageXOffset + window.innerWidth) &&
                    (top + height) > window.pageYOffset &&
                    (left + width) > window.pageXOffset;

                if(loadMore && !this.loading){
                    this.loadItems(this.lastPage+1);
                }
            }
        },

        loadItems(newPage) {
            let that = this;
            if (newPage > that.currentPage) {
                this.loading = true;
            }
            else {
                this.prevLoading = true;
            }
            let url = new URL(window.location.href);
            let facets = url.searchParams.get('facets');
            if (typeof facets === 'undefined' || facets == null) {
                facets = '';
            }
            else {
                facets = '&facets=' + facets;
            }
            let priceMax = url.searchParams.get('priceMax');
            if (typeof priceMax === 'undefined' || priceMax == null) {
                priceMax = '';
            }
            else {
                priceMax = '&priceMax=' + priceMax;
            }
            let priceMin = url.searchParams.get('priceMin');
            if (typeof priceMin === 'undefined' || priceMin == null) {
                priceMin = '';
            }
            else {
                priceMin = '&priceMin=' + priceMin;
            }

            let route = "category?items=";
            let catIdString = "";
            if(App.templateType == "search"){
                let sQuery = "";
                let queryStringArr = window.location.search.split("=");
                queryStringArr = queryStringArr[1].split("&");
                sQuery = queryStringArr[0];
                route = "item/search?query="+sQuery+"&items=";
            }else{
                catIdString = "&categoryId=" + this.currentCategory.id;
            }

            ApiService.get(
                window.location.origin + '/rest/io/'+route + this.itemsPerPage + '&sorting=' +
                this.sorting +
                '&page=' + (newPage) + catIdString + facets + priceMin + priceMax).done(response => {
                if (newPage > that.currentPage) {
                    that.items = that.items.concat(response.itemList.documents);
                    that.currentPage = newPage;
                    that.lastPage = newPage;
                    that.loading = false;
                }
                else {
                    that.prevItems = response.itemList.documents.concat(that.prevItems);
                    that.currentPage = newPage;
                    that.firstPage = newPage;
                    that.prevLoading = false;
                }
                let newHref = that.replaceUrlParam(window.location.href, 'page', that.currentPage);
                window.history.replaceState({}, '', newHref);
            });
        },
        replaceUrlParam(url, paramName, paramValue) {
            if (paramValue == null) {
                paramValue = '';
            }

            let pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
            if (url.search(pattern) >= 0) {
                return url.replace(pattern, '$1' + paramValue + '$2');
            }
            url = url.replace(/[?#]$/, '');
            return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
        },
    },
};
</script>
